/**
 * @file IconAlipay Icon
 * @author Auto Generated by @polyv/icons-cli
 */

import { IconBuilder } from '@polyv/icons-vue/icon-builder';

export default IconBuilder(
  'icon-alipay',
  (data) => `
<svg width="${data.size}" height="${data.size}" fill="none" viewBox="0 0 24 24">
  <defs>
    <clipPath><rect width="24" height="24" x="0" y="0" rx="0" /></clipPath>
  </defs>
  <g clip-path="url(#master_svg0_1_31591)">
    <g>
      <path
        fill="${data.colorDesc[0]}"
        fill-opacity="1"
        d="M5.4087,13.513C5.11304,13.7391,4.81739,14.0696,4.73043,14.5043C4.6087,15.0783,4.71304,15.8087,5.25217,16.3826C5.93043,17.0609,6.95652,17.2522,7.4087,17.287C8.6087,17.3739,9.89565,16.7652,10.8696,16.1043C11.2522,15.8435,11.8957,15.3043,12.5217,14.4696C11.1304,13.7565,9.3913,12.9565,7.54783,13.0261C6.57391,13.0609,5.89565,13.2522,5.4087,13.513ZM23.0435,16.6957C23.6522,15.2522,24,13.6696,24,12C24,5.3913,18.6087,0,12,0C5.3913,0,0,5.3913,0,12C0,18.6087,5.3913,24,12,24C16,24,19.5304,22.0348,21.7217,19.0261C19.6522,18.0174,16.2609,16.313,14.1565,15.3043C13.1652,16.4522,11.687,17.5826,10.0174,18.0696C8.97391,18.3826,8.01739,18.5043,7.04348,18.2957C6.05217,18.087,5.33913,17.6348,4.92174,17.1826C4.71304,16.9391,4.46957,16.6609,4.27826,16.2957C4.29565,16.313,4.29565,16.3478,4.29565,16.3652Q4.1913,16.1913,4.12174,15.913C4.08696,15.7739,4.05217,15.6348,4.03478,15.4957C4.01739,15.3913,4.01739,15.287,4.03478,15.2C4.01739,15.0261,4.03478,14.8348,4.06957,14.6435C4.17391,14.1565,4.36522,13.6174,4.90435,13.113C6.05217,11.9826,7.6,11.9304,8.4,11.9304C9.58261,11.9478,11.6348,12.4522,13.3739,13.0783C13.8609,12.0522,14.1739,10.9739,14.3652,10.2261L7.14783,10.2261L7.14783,9.44348L10.8522,9.44348L10.8522,7.87826L6.38261,7.87826L6.38261,7.07826L10.8522,7.07826L10.8522,5.51305C10.8522,5.30435,10.9043,5.13044,11.2348,5.13044L12.9913,5.13044L12.9913,7.07826L17.8435,7.07826L17.8435,7.86087L12.9913,7.86087L12.9913,9.42609L16.8696,9.42609Q16.4696,11.6,15.2696,13.7391C17.9652,14.6957,21.7739,16.1913,23.0435,16.6957Z"
        style="mix-blend-mode: passthrough"
      />
    </g>
  </g>
</svg>
`
);
